import styled from 'styled-components'
import { grayDarker } from '@bufferapp/ui/style/colors'

import { flexCol, flexRow } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

/**
 *
 */

export const Wrapper = styled.div`
  ${flexCol}
  justify-content: center;
  align-items: center;
  width: 350px;
  height: 100%;
  margin: 0px auto;
`

export const Image = styled.img`
  width: 300px;
  margin: 16px 0px;
`

export const Title = styled.p`
  ${baseFont}
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  color: ${grayDarker};
`

export const Subtitle = styled.p`
  ${baseFont}
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  color: ${grayDarker};
`

export const ButtonWrapper = styled.div`
  ${flexRow}
  margin: 16px 0px;

  & > * {
    margin: 0px 4px;
  }
`
